<button class="menu__icon-notification mr-3"
        mat-icon-button
        [matTooltip]="'Notificações'"
        matTooltipPosition="above"
        [matMenuTriggerFor]="menuNotifications">

  <mat-icon [matBadge]="getCountUnreadNotifications() || ''"
            matBadgeColor="warn"
            matBadgeSize="small">notifications
  </mat-icon>
</button>

<mat-menu #menuNotifications="matMenu"
          class="menu-notificacao">

  <mat-action-row (click)="$event.stopPropagation();"
                  *ngIf="notifications?.length > 0">
    <button mat-stroked-button
            (click)="readAllNotifications()">
      <mat-icon class="mr-3">check</mat-icon> Marcar todas como lidas
    </button>
  </mat-action-row>

  <mat-accordion (click)="$event.stopPropagation();"
                 *ngIf="notifications?.length > 0">

    <mat-expansion-panel hideToggle
                         *ngFor="let item of notifications">
      <mat-expansion-panel-header>
        <mat-panel-title>

          <span [ngSwitch]="item.notificacao.tipo">
            <mat-icon class="mr-3"
                      *ngSwitchCase="'AGENDAMENTO'">calendar_today</mat-icon>
            <mat-icon class="mr-3"
                      *ngSwitchCase="'FINANCEIRO'">attach_money</mat-icon>
            <mat-icon class="mr-3"
                      *ngSwitchCase="'GENERICO'">alarm</mat-icon>
            <mat-icon class="mr-3"
                      *ngSwitchDefault>notifications_active</mat-icon>
          </span>

          <span *ngIf="item.lido">{{item.notificacao.titulo}}</span>
          <b *ngIf="!item.lido">
            {{item.notificacao.titulo}}
            <mat-icon>fiber_new</mat-icon>

            <button mat-icon-button>
              <mat-icon *ngIf="item.notificacao.linkRedirecionamento || item.notificacao.linkConteudo"
                        (click)="openLink(item.notificacao.linkRedirecionamento || item.notificacao.linkConteudo)">
                open_in_new</mat-icon>
            </button>
          </b>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <p>{{item.notificacao.textoPrincipal}}</p>

      <mat-dialog-actions fxLayout="row"
                          fxLayoutAlign="end">

        <div class="notification-dialog__confirm">
          <input mat-raised-button
                 [disabled]="item.lido"
                 [checked]="item.lido"
                 (click)="onRead(item)"
                 type="checkbox"
                 color="primary" />
          Lido
        </div>
      </mat-dialog-actions>
    </mat-expansion-panel>

  </mat-accordion>

  <button fxLayoutAlign="center"
          mat-menu-item
          ghost
          routerLink="notificacao"
          [ngClass]="{'mt-2' : notifications?.length > 0}">
    <span>Ver todas as notificações</span>
  </button>
</mat-menu>
